// extracted by mini-css-extract-plugin
export default {"main":"styles_main__9kLiF","main__left":"styles_main__left__NBmGk","main__right":"styles_main__right__IcmnL"};